import { language } from '@getpopsure/i18n-react';
import { website } from '@getpopsure/private-constants';
import classNames from 'classnames';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { useRegion } from 'hooks/useRegion';
import { GenericQuestionnaireState } from 'reducers/genericQuestionnaire';

import logo from './assets/logo.svg';
import logoDesktop from './assets/logo-desktop.svg';
import { SendToCustomerButton } from './components/SendToCustomerButton/SendToCustomerButton';
import { useGetAffiliateDataFromUrlOrCookie } from './hooks/useGetAffiliateDataFromUrlOrCookie';
import styles from './styles.module.scss';

export const AffiliateNavBar = ({
  answers,
  verticalId,
}: {
  answers: Record<string, unknown>;
  verticalId: string;
}) => {
  const { region } = useRegion();
  const locale = language();
  const affiliateData = useGetAffiliateDataFromUrlOrCookie();

  if (!affiliateData?.id) {
    return null;
  }

  return (
    <div className={classNames(styles.navBar, 'bg-white d-flex jc-center')}>
      <div
        className={classNames(
          styles.navbarContent,
          'w100 d-flex ai-center jc-between px32'
        )}
      >
        <a
          href={`${website.base}/${locale}-${region}`}
          className="d-flex ai-center jc-center"
        >
          <img src={logoDesktop} className={styles.logoDesktop} alt="Home" />
          <img src={logo} className={styles.logoMobile} alt="Home" />
        </a>
        <div
          className={classNames(styles.buttonsContainer, 'd-flex ai-center')}
        >
          {answers && (
            <SendToCustomerButton
              affiliateId={affiliateData?.id}
              affiliateSource={affiliateData?.source}
              questionnaireAnswers={answers}
              verticalId={verticalId as keyof GenericQuestionnaireState}
            />
          )}

          <LanguageSwitcher type="dropdown" />
        </div>
      </div>
    </div>
  );
};
